"use client";

import React from "react";
import { Linkedin, Mail, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4 animate-pulse justify-center">
        <div className="h-5 w-20 bg-background/10 rounded-md" />
        <div className="h-5 w-24 bg-background/10 rounded-md" />
        <div className="h-5 w-16 bg-background/10 rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="mx-auto max-w-full">
      <NavigationMenuList className="flex flex-wrap items-center justify-center gap-2 sm:gap-4">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild className="bg-transparent hover:bg-background/10 focus:bg-background/10 text-background/60 hover:text-background focus:text-background data-[active=true]:bg-background/10 data-[active=true]:text-background px-3 py-2 rounded-md transition-colors">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
        {}
        <NavigationMenuItem data-index={menuItems.length}>
          <NavigationMenuLink asChild className="bg-transparent hover:bg-background/10 focus:bg-background/10 text-background/60 hover:text-background focus:text-background data-[active=true]:bg-background/10 data-[active=true]:text-background px-3 py-2 rounded-md transition-colors">
            <Link to="#">Privacy Policy</Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem data-index={menuItems.length + 1}>
          <NavigationMenuLink asChild className="bg-transparent hover:bg-background/10 focus:bg-background/10 text-background/60 hover:text-background focus:text-background data-[active=true]:bg-background/10 data-[active=true]:text-background px-3 py-2 rounded-md transition-colors">
            <Link to="#">Resume</Link>
          </NavigationMenuLink>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <section id="footer" className="bg-foreground py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center text-center md:text-left">
          
          {}
          <div className="flex justify-center md:justify-start">
            <Link to="/" className="inline-block transition-opacity hover:opacity-80">
              <span className="text-3xl font-serif font-bold tracking-tighter text-background">
                NH.
              </span>
            </Link>
          </div>

          {}
          <div className="flex justify-center w-full overflow-hidden">
            <MenuProvider menu_id="16">
              <FooterNav />
            </MenuProvider>
          </div>

          {}
          <div className="flex justify-center md:justify-end gap-2">
            <Button variant="ghost" size="icon" asChild className="text-background/60 hover:text-background hover:bg-background/10 rounded-full transition-colors">
              <Link to="https://linkedin.com" newTab aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" asChild className="text-background/60 hover:text-background hover:bg-background/10 rounded-full transition-colors">
              <Link to="https://twitter.com" newTab aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" asChild className="text-background/60 hover:text-background hover:bg-background/10 rounded-full transition-colors">
              <Link to="mailto:nathan.harrington@loyola.edu" aria-label="Email">
                <Mail className="size-5" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-background/10 text-center">
          <p className="text-sm text-background/40">
            &copy; {new Date().getFullYear()} Nathan Harrington. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}